// @flow

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toastr } from 'react-redux-toastr';
import Modal from '../../../commons/modal/modal';
import styles from './depositSlipModal.scss';
import Popover from '../../../commons/popover/popover';
import InputField from '../../../commons/formElements/inputField/inputField';
import {
  getDepositSlipDetailForModal,
  submitBankSlipDetailAction
} from './depositSlipDashboardRedux/depositSlipDashboardActionCreator';
import upload from '../../../../assets/images/upload-theme.svg';
import closeIcon from '../../../../assets/images/close_icn_blue.svg';
import Loader from '../../../commons/loader/loader';

type Props = {
  showModal: boolean,
  closeModal: Function,
  title: string,
  depositSlipDetail: Object,
  depositSlipId: number,
  getDepositSlipDetailForModal: funtion
};

type State = {
  showPopover: boolean,
  bankSlipNumber: string,
  bankReceiptFile: File
};

const ModalCell = props => (
  <div className={`flex-100 l-row j-space-bet ${props.cellStyle}`}>
    <span
      className={`${styles.index} ${styles.textStyle} ${props.headerStyle}`}
    >
      {props.header}
    </span>
    <span className={`${styles.key} ${styles.textStyle} ${props.valueStyle}`}>
      {props.value}
    </span>
  </div>
);

class DepositSlipDetail extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showPopover: false,
      bankSlipNumber: null,
      bankReceiptFile: null
    };
    this.submit = this.submit.bind(this);
  }

  componentWillReceiveProps(nextProps: Object) {
    if (
      nextProps.depositSlipId &&
      this.props.depositSlipId !== nextProps.depositSlipId
    ) {
      this.setState({
        bankReceiptFile: null
      });
      if (document.getElementById('uploadOriginalReceipt')) {
        document.getElementById('uploadOriginalReceipt').value = null;
      }

      this.props.getDepositSlipDetailForModal({ id: nextProps.depositSlipId });
    }
    if (nextProps.showModal !== this.props.showModal)
      this.setState({
        showPopover: false
      });

    if (
      this.props.depositSlipDetail &&
      nextProps.depositSlipDetail &&
      nextProps.depositSlipDetail.bankSlipNumber !==
        this.props.depositSlipDetail.bankSlipNumber
    ) {
      this.setState({
        bankSlipNumber: nextProps.depositSlipDetail.bankSlipNumber
      });
    }
  }

  togglePopover() {
    this.setState({
      showPopover: !this.state.showPopover
    });
  }

  onFileChange(target) {
    const file = target.files[0] || null;
    this.setState({ bankReceiptFile: file });
  }

  renderEditableFields = () => {
    const { bankReceiptFile } = this.state;
    return (
      <div className={styles.editableFields}>
        <div className={styles.inputBoxWrapper}>
          <label>CMS/Bank Slip Number</label>
          <InputField
            name="bankSlipNumber"
            type="text"
            placeholder="CMS/Bank Slip Number"
            onChange={(val, target) => {
              this.setState({
                bankSlipNumber: val
              });
            }}
            value={this.state.bankSlipNumber || ''}
            inputClassName={styles.inputClassName}
            disabled={false}
          />
        </div>
        <div className={styles.uploadReceiptWrapper}>
          <div className={styles.uploadReceipt}>
            <label> Original Receipt </label>
            <input
              type="file"
              id="uploadOriginalReceipt"
              accept="image/*"
              onChange={e => this.onFileChange(e.target)}
            />
            <div
              className={styles.imageUploader}
              onClick={e => {
                e.stopPropagation();
                if (bankReceiptFile) {
                  this.setState({ bankReceiptFile: null }, () => {
                    document.getElementById(
                      'uploadOriginalReceipt'
                    ).value = null;
                  });
                } else {
                  document.getElementById('uploadOriginalReceipt').click();
                }
              }}
            >
              <button>
                {bankReceiptFile ? (
                  <div
                    className="text-wrap-ellipsis"
                    style={{ maxWidth: '200px' }}
                  >
                    {bankReceiptFile.name}
                    <img src={closeIcon} className={styles.close} />
                  </div>
                ) : (
                  <span>
                    Upload Original Receipt
                    <img src={upload} />
                  </span>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  submit() {
    const { bankSlipNumber, bankReceiptFile } = this.state;
    if (!bankSlipNumber && !bankReceiptFile) {
      toastr.error('Please enter bank slip number or upload bank receipt', {
        timeout: 3000
      });
      return;
    }
    this.props.submitBankSlipDetailAction(
      {
        bankSlipNumber,
        bankReceiptFile,
        depositSlipId: this.props.depositSlipId
      },
      () => {
        this.props.getDepositSlipDetailForModal({
          id: this.props.depositSlipId
        });
        this.props.closeModal();
      }
    );
  }

  render() {
    const { submitBankSlipModalLoader, type } = this.props;
    return (
      <Modal
        showModal={this.props.showModal}
        title={this.props.title}
        closeModal={() => {
          this.props.closeModal();
        }}
      >
        {!submitBankSlipModalLoader ? (
          <div className={`${styles.modalWrapper}`}>
            {type === 'mapToBankSlips' && this.renderEditableFields()}
            <div className="flex-100 l-row">
              <div className="flex-50 l-col j-start">
                <ModalCell
                  header="Slip id"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.depositSlipNumber
                  }
                />
                <ModalCell
                  header="Deposit Date"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.depositSlipGenerationDate
                  }
                />
                <ModalCell
                  valueStyle={styles.textWrap}
                  header="Deposited By"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.depositedBy &&
                    this.props.depositSlipDetail.depositedBy.name
                  }
                />
                <ModalCell
                  header="Mode of Deposit"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.depositSlipType
                  }
                />
                <ModalCell
                  header="Type of Deposit"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.paymentType
                  }
                />
                <ModalCell
                  header="Status"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.status
                  }
                />
                <ModalCell
                  valueStyle={styles.textWrap}
                  header="Reason for Manual Deposit"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.reason
                  }
                />
                {type !== 'mapToBankSlips' &&
                  this.props.depositSlipDetail.depositSlipType ===
                    'DIGITAL' && (
                    <div>
                      <ModalCell
                        valueStyle={styles.textWrap}
                        header="Bank Slip Receipt"
                        value={''}
                      />
                      <img
                        src={this.props.depositSlipDetail.bankReceiptUrl}
                        style={{
                          maxWidth: '90%',
                          maxHeight: '200px'
                        }}
                      />
                    </div>
                  )}
              </div>
              <div className="flex-50 l-col j-start">
                {type !== 'mapToBankSlips' &&
                  this.props.depositSlipDetail.depositSlipType ===
                    'DIGITAL' && (
                    <ModalCell
                      header="CMS/Bank Slip Number"
                      value={
                        this.props.depositSlipDetail &&
                        this.props.depositSlipDetail.bankSlipNumber
                      }
                    />
                  )}
                <ModalCell
                  header="Deposited Amount"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.depositedAmount
                  }
                />
                <ModalCell
                  header="Collection Amount"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.collectionAmount
                  }
                />
                <ModalCell
                  header="Deposited OU"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.locationCode
                  }
                />
                <div className="flex-100 l-row">
                  <span className={`${styles.index} ${styles.textStyle}`}>
                    Cnotes
                  </span>
                  {this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.cnotes &&
                    this.props.depositSlipDetail.cnotes.length > 0 && (
                      <span className={`${styles.key} ${styles.textStyle}`}>
                        {this.props.depositSlipDetail.cnotes
                          .slice(0, 6)
                          .join(', ')}
                        {this.props.depositSlipDetail.cnotes.length > 6 && (
                          <div>
                            <div
                              className={`${styles.moreRectangle}`}
                              onClick={() => this.togglePopover()}
                            >
                              More
                            </div>
                            <div style={{ position: 'relative', zIndex: 2 }}>
                              <Popover showPopover={this.state.showPopover}>
                                <div>
                                  {this.props.depositSlipDetail.cnotes.join(
                                    ', '
                                  )}
                                </div>
                              </Popover>
                            </div>
                          </div>
                        )}
                      </span>
                    )}
                </div>
                <ModalCell
                  valueStyle={styles.textWrap}
                  header="Remarks"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.remarks
                  }
                />
                <ModalCell
                  valueStyle={styles.textWrap}
                  header="Cancellation Reason"
                  value={
                    this.props.depositSlipDetail &&
                    this.props.depositSlipDetail.cancellationReason
                  }
                />
              </div>
            </div>
            {this.props.depositSlipDetail &&
              this.props.depositSlipDetail.documentUrl && (
                <div>
                  <div className="flex-100 l-row">
                    <span
                      className={`${styles.index} ${styles.textStyle} flex-25 l-col j-start`}
                    >
                      Supporting Documents
                    </span>
                    <span
                      className={`${styles.key} ${styles.textStyle} flex-75 l-col j-start`}
                    >
                      <img
                        className={`${styles.imageRectangle}`}
                        src={this.props.depositSlipDetail.documentUrl}
                        alt="Preview of document not available. Click View Deposit Slip to download"
                      />
                    </span>
                  </div>
                  <div className="flex-100 l-row ">
                    <a
                      href={this.props.depositSlipDetail.documentUrl}
                      target="-_blank"
                      className={`${styles.downloadViewSlip}`}
                    >
                      View deposit slip
                    </a>
                  </div>
                </div>
              )}
            {type === 'mapToBankSlips' && (
              <div
                className={`action-button-wrapper ${styles.submit}`}
                onClick={this.submit}
              >
                <div className="action-button">SUBMIT</div>
              </div>
            )}
          </div>
        ) : (
          <div style={{ minHeight: '400px', minWidth: '500px' }}>
            <Loader />
          </div>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  depositSlipDetail: state.depositSlipDashboardState.depositSlipDetail
});

const mapDispatchToProps = dispatch => ({
  getDepositSlipDetailForModal: bindActionCreators(
    getDepositSlipDetailForModal,
    dispatch
  ),
  submitBankSlipDetailAction: bindActionCreators(
    submitBankSlipDetailAction,
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(DepositSlipDetail);
